import paths from './animated-artwork.json';

type ArtworkPaths = (typeof paths)['quanta'];

export function versionArtwork(artwork: ArtworkPaths, version?: string) {
  const url = (path: string) => (version ? `${path}?v=${encodeURIComponent(version)}` : path);
  return {
    poster: url(artwork.poster),
    fallback: url(artwork.fallback),
    clips: { webm: url(artwork.webm), hevc: url(artwork.hevc) },
  };
}

export const quantaArtwork = versionArtwork(paths.quanta, process.env.NEXT_PUBLIC_QUANTA_ARTWORK_VERSION);
export const faucetArtwork = versionArtwork(paths.faucet, process.env.NEXT_PUBLIC_FAUCET_ARTWORK_VERSION);
